<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="10">
        <el-form ref="form" size="mini" :model="formData" :rules="rules">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_shipmentNo') || '外运编号'"
                prop="contractNo"
              >
                <el-input
                  v-model.trim="formData.contractNo"
                  :placeholder="
                    $l('INDEX.form_placeholder_shipmentNo') || '请输入外运编号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
                "
                prop="dispatchPort"
              >
                <dict-select
                  filterable
                  v-model="formData.dispatchPort"
                  url="/master/port/select"
                  size="mini"
                  clearable
                  :placeholder="
                    $l('INDEX.form_placeholder_dispatchPort') ||
                      '请选择发运港口'
                  "
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.form_bookingType') || '订舱类型'">
                <el-select
                  v-model="formData.bookingType"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    :label="$l('INDEX.form_bookingType_A') || '整箱'"
                    value="A"
                  ></el-option>
                  <el-option
                    :label="$l('INDEX.form_bookingType_B') || '拼箱'"
                    value="B"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_label_bookingDate') || '订舱日期'"
                prop="bookingDate"
              >
                <el-date-picker
                  v-model="formData.bookingDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_bookingDate') || '请选择订舱日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('INDEX.form_label_plannedETD') || '计划发运日期'"
              >
                <el-date-picker
                  v-model="formData.plannedETD"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="
                    $l('INDEX.form_placeholder_plannedETD') ||
                      '请选择计划发运日期'
                  "
                  style="width: 100%"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_quotedMethod') || '报价方式'"
                prop="quotedMethod"
              >
                <dict-select
                  url="/sys/common/dict/system"
                  v-model="formData.quotedMethod"
                  :body="quotedMethodParams"
                  :placeholder="
                    $l('INDEX.sample_tips_select_quotation_method') ||
                      '请选择报价方式'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.form_shipmentType') || '发运方式'"
                prop="shipmentType"
              >
                <dict-select
                  url="/master/common/dict/biz"
                  v-model="formData.shipmentType"
                  :body="shipmentTypeParams"
                  :placeholder="
                    $l('INDEX.form_placeholder_shipmentTypes') ||
                      '请选择发运方式'
                  "
                  size="mini"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="d-flex justify-content-end mt-2 mb-2">
            <el-button type="primary" size="small" @click="save()">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="24">
            <ContainerTable
              v-if="shipmentBookingCode"
              :shipmentCode="shipmentCode"
              :shipmentBookingCode="shipmentBookingCode"
              :isNStatus="isNStatus"
              :height="310"
              ref="containerTable"
            />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ContainerTable from '../container'
export default {
  mixins: [EditLoading],
  components: { ContainerTable },
  props: {
    shipmentCode: { type: String, default: '' },
    bookingCode: { type: String, default: '' },
    shipmentStatus: { type: String, default: '' },
    isNStatus: { type: Boolean, default: false },
  },
  data() {
    return {
      shipmentTypeParams: { dictType: 'shipmentType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      formData: { dispatchPort: '', destinationPort: '', bookingType: 'A' },
      backDialogVisible: false,
      shipmentBookingCode: '',
      rules: {
        dispatchPort: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_dispatchPort') ||
              '请选择发运港口',
            trigger: 'change',
          },
        ],
        contractNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_shipmentNo') || '请输入外运编号',
            trigger: 'blur',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('INDEX.sample_tips_select_quotation_method') ||
              '请选择报价方式',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    bookingCode: {
      handler(val) {
        if (val) {
          this.shipmentBookingCode = val
        }
      },
      immediate: true,
    },
  },
  computed: {},
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.shipmentCode || !this.shipmentBookingCode) return
      this.$api
        .shipmentBookingDetailApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
        .catch(() => {})
    },
    async save() {
      const result = await this.validateData()
      if (!result) return
      const params = {
        ...this.formData,
        shipmentCode: this.shipmentCode,
        shipmentBookingCode: this.shipmentBookingCode,
      }
      this.loadingOpen()
      this.$api
        .shipmentBookingSaveApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
          if (!this.shipmentBookingCode) {
            this.shipmentBookingCode = res.body
            this.loadData()
            return
          }
          this.close()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async validateData() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
